<div class="building-condition stage{{stage}}" [class.singlehouse]="!isApartementBuilding">
  <strong [innerHTML]="textKeyPrefix + '.subheadline' | translate: textPlaceholder"></strong>
  <div class="building" #building>
    @if (isApartementBuilding) {
      <svg
        aria-hidden="true"
        class="apartment-building"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 84 93">
      <path class="wall" d="M55.7,23.3H27.9H7.5v67.6h27.9V67.5h15.1v23.4h26.2V23.3H55.7z M14.7,26.8h9.8v9.8h-9.8V26.8z M14.7,47.8h9.8
          v9.8h-9.8V47.8z M24.5,78.9h-9.8V68.7h9.8V78.9z M46.7,57.6h-9.8v-9.8h9.8V57.6z M46.7,36.6h-9.8v-9.8h9.8V36.6z M68.8,79.7H59
          V68.8h9.8V79.7z M68.9,57.6h-9.8v-9.8h9.8V57.6z M68.9,36.6h-9.8v-9.8h9.8V36.6z"/>
        <path [ngClass]="markFloorInApartement ? 'gray-roof' : 'roof'"
          d="M77.4,21.8h-1.3L64.6,8.5V7.7H25.4V3.6h0.8V1.7h-7.4v1.9h0.7v4.1h-3.1v0.8h0.1l-9,13.3H6.6
          c0,0-0.8,0.2-0.8,0.7s0.7,0.8,0.7,0.8h0.9l0,0h16h4.4h27.8l0,0l0,0h20.9v0.1h0.8h0.1l0,0l0,0c0,0,0.7-0.4,0.7-0.8
          C78.2,22,77.4,21.8,77.4,21.8z"/>
        <path [ngClass]="markFloorInApartement ? 'floor' : 'gray-floor'"
          d="M7.5,42.3v20.9h69.1V42.3H7.5z M24.5,57.6h-9.8v-9.9h9.9L24.5,57.6L24.5,57.6z M46.7,57.6h-9.9v-9.9h9.9
          C46.7,47.7,46.7,57.6,46.7,57.6z M68.9,57.6H59v-9.9h9.9V57.6z"/>
      </svg>
    }

    @if (!isApartementBuilding) {
      <svg
        aria-hidden="true"
        class="singlehouse"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 84 93">
      <path class="roof" d="M80.8,35h-1.4L66.8,20.4v-0.9H45l-2.2-2.4l-2.4,2.4H23.7V15h0.9v-2.1h-8.1V15h0.8v4.5h-3.4v0.9H14L4,35H3
		    c0,0-0.9,0.3-0.9,0.8s0.8,0.9,0.8,0.9h1v-0.1h17.6h4.8l16.3-16.3l14.3,16.3l0,0l0,0h22.9v0.1h0.9h0.1l0,0l0,0c0,0,0.8-0.4,0.8-0.9
		    C81.7,35.3,80.8,35,80.8,35z"/>
      <path class="wall" d="M57,36.7L42.7,20.4L26.4,36.7H3.9v43.8h30.7V54.8h16.6v25.7H80V36.7H57z M22.7,67.3H11.9V56.1h10.8V67.3z
		    M48.3,43.8H37.5V33h10.8V43.8z M71.4,68.2H60.6v-12h10.8V68.2z"/>
      </svg>
    }

    <span class="label">{{textKeyPrefix + '.yourbuilding' | translate: textPlaceholder }}</span>
  </div>

  <ol class="stages">
    @for (currentStage of stages; track currentStage; let i = $index) {
      <li class="stage{{i}}" [class.active]="i === stage">
        <strong>{{ currentStage }}</strong>
        <span class="label" [innerHTML]="textKeyPrefix + '.stage.' + i | translate: textPlaceholder"></span>
      </li>
    }
  </ol>
  <div class="direction">
    <span></span>
    <span class="label" [innerHTML]="textKeyPrefix + '.better' | translate"></span>
  </div>
  @if (showAverage) {
    <div class="avg" [class.higher]="stage < 2" [innerHTML]="(textKeyPrefix + '.average.' + stage) | translate: textPlaceholder"></div>
  }
  @if (hasHint) {
    <div class="infotext-wrapper">
      <button type="button" [attr.aria-expanded]="showHint" aria-controls="hint" [attr.aria-label]="'arialabel.toggle.info.building' | translate" (click)="showHint = !showHint" class="infocallout-button"><i class="icon-info"></i> <span [innerHTML]="textKeyPrefix + '.yourbuilding.hint.label' | translate: textPlaceholder"></span></button>
      @if (showHint) {
        <div class="callout infocallout lighter-gray">
          <button type="button" class="close" [attr.aria-label]="'arialabel.close' | translate" (click)="showHint = false"><i class="icon-x"></i></button>
          <p id="hint" [innerHTML]="textKeyPrefix + '.yourbuilding.hint' + hintTextPostfix | translate: textPlaceholder"></p>
        </div>
      }
    </div>
  }
</div>
